import React from 'react';
import { TradeViewerPage } from '@/components/trade-viewer/TradeViewerPage';

/**
 * Public, unauthenticated page for an expiring scenario share link.
 *
 * Rendered for `#/shared-scenario?key=<token>` OUTSIDE the dashboard auth
 * gate (see App.tsx) so a recipient without an account can open the link.
 * TradeViewerPage detects the `?key=` param and runs in read-only shared
 * mode, resolving the token via the anonymous-safe `by-share` endpoint.
 */
export const SharedScenarioPage: React.FC = () => (
  <div className="min-h-screen bg-background text-foreground">
    <TradeViewerPage />
  </div>
);

export default SharedScenarioPage;
